import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=454a4041&"
import script from "./Contract.vue?vue&type=script&lang=ts&"
export * from "./Contract.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports